import { Button } from '@/components/ui/button';
import { ChevronDown } from 'lucide-react';
import GlutenFreeIcon from '@/components/GlutenFreeIcon';
import { useCart } from '@/context/CartContext';
import { Link } from 'react-router-dom';

const Hero = () => {
  const { ordersEnabled } = useCart();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - headerHeight, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-background" />
      
      {/* Decorative elements */}
      <div className="absolute top-1/4 left-10 w-64 h-64 bg-primary/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-10 w-96 h-96 bg-accent/10 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 pt-20 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Title */}
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold mb-6 animate-fade-in" style={{ animationDelay: '0.1s' }}>
            <span className="text-foreground">Pizzeria</span>
            <br />
            <span className="text-gradient">La Torre</span>
            <span className="sr-only"> – Pizzeria a Carmagnola con Pizza Senza Glutine</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Dall'amore per il nostro lavoro nascono sapori autentici, 
            ingredienti selezionati e un impasto che racconta la tradizione di famiglia.
          </p>

          {/* Badge */}
          <Link to="/aic" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-muted border border-border mb-8 animate-fade-in hover:border-green-500/40 transition-colors" style={{ animationDelay: '0.25s' }}>
            <GlutenFreeIcon className="h-5 w-5 text-green-400" />
            <span className="text-sm text-muted-foreground">Tutte le pizze sono disponibili anche <span className="text-green-400 font-semibold">senza glutine</span></span>
          </Link>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <Button variant="hero" size="lg" asChild>
              <Link to="/menu">
                {ordersEnabled ? 'Sfoglia il Menù e Ordina' : 'Sfoglia il Menù'}
              </Link>
            </Button>
            <Button variant="heroOutline" size="lg" onClick={() => scrollToSection('contatti')}>
              Contattaci
            </Button>
          </div>

          {/* Scroll indicator */}
          <div className="mt-16 animate-bounce">
            <button onClick={() => scrollToSection('chi-siamo')} className="text-muted-foreground hover:text-primary transition-colors">
              <ChevronDown className="h-8 w-8 mx-auto" />
            </button>
          </div>
        </div>
      </div>
    </section>);

};

export default Hero;